module.exports = __webpack_public_path__ + "static/covid-b7abb5fdfd41fb471459d205af5cc508.png";